import { Component, EventEmitter, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Job, JobPayment } from '../../../../../data/models';

@Component({
    selector: 'app-job-invoices-attach-order-modal',
    templateUrl: './job-invoices-attach-order-modal.component.html',
    standalone: false,
})
export class JobInvoicesAttachOrderModalComponent implements OnInit {
    // @ts-ignore TS2564
    job: Job;
    rows: JobPayment[] = [];
    action = new EventEmitter<any>();

    constructor(private bsModalRef: BsModalRef) {}

    ngOnInit(): void {
        // @ts-ignore TS2532
        this.rows = this.job.JobPayments.filter((p) => {
            return !p.IsDeleted && p.Status === 'Pending';
        });
    }

    selectJobPayment(jobPayment: JobPayment) {
        this.bsModalRef.hide();
        this.action.emit({ cancelled: false, jobPayment });
    }

    cancel() {
        this.bsModalRef.hide();
        this.action.emit({ cancelled: true });
    }
}
